import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const DriverRequest = {
  // Fetch filtered list of users
  userFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getUserFilterSet}`, {
      withCredentials: true,
      params: {
        name: values?.name,
        mobile: values?.mobile,
        roleId: 3,
        ownerId: values?.ownerId,
        isActive: values?.isActive,
      },
    }),
};

export default DriverRequest;
